module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lipBalms_6506a9.jpg";